// extracted by mini-css-extract-plugin
module.exports = {"title":"Bid_title__2NBH4","info":"Bid_info__37zwI","stage":"Bid_stage__2zLBs","row":"Bid_row__6tRb4","col":"Bid_col__1D9u0","btns":"Bid_btns__2YuhO","button":"Bid_button__1p9Tf"};